import log from 'salvo-lite/log'

class Scheduler {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        // eslint-disable-next-line no-useless-escape
        this._start = elem.getAttribute('data-start') ? elem.getAttribute('data-start').replace(/[^0-9\.]+/g, '') : null
        // eslint-disable-next-line no-useless-escape
        this._end = elem.getAttribute('data-end') ? elem.getAttribute('data-end').replace(/[^0-9\.]+/g, '') : null
        this._timezone = parseInt(elem.getAttribute('data-timezone')) || 0
        this._current = new Date()
        this._data = JSON.parse(elem.getAttribute('data-scheduler') || '{}')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        const location = this._data.location
        const daylightSaving = this._data.daylight_saving
        let offset = 0

        if (location === 'AU') {
            // AEST + 10 UTC
            offset = 10
        } else if (location === 'EU') {
            // CET + 1 UTC
            offset = 1
        } else if (location === 'US') {
            // EST - 5 UTC
            offset = -5
        } else {
            // GMT + 0
            offset = 0
        }
        if (daylightSaving === 'true') {
            offset = offset + 1
        }
        const startDate = Number(this._start)
        const endDate = Number(this._end)
        const year = this._current.getUTCFullYear().toString()
        const month = ('0' + (this._current.getUTCMonth() + 1)).slice(-2).toString()
        const day = ('0' + this._current.getUTCDate()).slice(-2).toString()
        const hour = ('0' + ((0 + offset + this._current.getUTCHours()))).toString().slice(-2).toString()
        const min = ('0' + this._current.getUTCMinutes()).slice(-2).toString()
        const date = parseInt(day.concat(month, year, hour, min))

        if (startDate && endDate) {
            if (this._start <= date && date < this._end) {
                this._elem.classList.remove('visually-hidden')
            }
        } else if (startDate) {
            if (startDate <= date) {
                this._elem.classList.remove('visually-hidden')
            }
        } else if (endDate) {
            if (date < endDate) {
                this._elem.classList.remove('visually-hidden')
            }
        }
    }
}

export default Scheduler



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Scheduler.js